import React from "react";
import RuleItem from "./RuleItem";

export default function RuleGroup({
  group,
  items,
  toggles,
  baseIdx,
  onToggle,
  dropdownValues = {},
  onDropdownChange,
}) {
  return (
    <section>
      <h3 className="text-sm font-bold text-gray-700 mb-2">{group}</h3>
      <ul className="space-y-3">
        {items.map((item, iIdx) => (
          <RuleItem
            key={item.name}
            name={item.name}
            desc={item.desc}
            checked={toggles[baseIdx + iIdx]}
            onToggle={() => onToggle(baseIdx + iIdx)}
            dropdown={item.dropdown}
            dropdownValue={
              item.dropdownKey ? dropdownValues[item.dropdownKey] : undefined
            }
            onDropdownChange={
              item.dropdownKey
                ? (val) => onDropdownChange(item.dropdownKey, val)
                : undefined
            }
          />
        ))}
      </ul>
    </section>
  );
}
